import { useEffect, useState } from 'react'

const DEFAULT_CONTAINER_ID = '__next'
export const useScrollPositionInfoById = (elementId = DEFAULT_CONTAINER_ID) => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const el = document.getElementById(elementId)
    if (!el) return

    const handleScroll = () => {
      setIsScrolled(el.scrollTop > 0)
    }
    el.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => el.removeEventListener('scroll', handleScroll)
  }, [elementId])

  return isScrolled
}
